module.exports = __webpack_public_path__ + "static/media/logo-mui.96938464.png";